import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    uploadFixedprices,
    getFixedpricesReport,
    getFixedprices,
    createFixedprice,
    updateFixedprice,
    deleteFixedprice
}

function uploadFixedprices(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/fixedprices/upload`)
           .set('access', Storage.getItem('access'))
           .attach('fixedpricesFile', data.fixedpricesFile)
           .field('deleteFixedprices', data.deleteFixedprices)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getFixedpricesReport(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/fixedprices/report`)
           .set('access', Storage.getItem('access'))
           .responseType('blob')
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getFixedprices(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/fixedprices`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createFixedprice(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/fixedprices`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateFixedprice(fixedpriceId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/fixedprices/${fixedpriceId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteFixedprice(fixedpriceId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/fixedprices/${fixedpriceId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}